import "./AppCrashScreen.scss";
import Button from "../Button";

export default function AppCrashScreen({ onRetry }) {
  const handleRetry = () => {
    if (typeof onRetry === "function") {
      onRetry();
    } else {
      window.location.reload();
    }
  };

  return (
    <div className="app-crash-overlay">
      <div className="app-crash-content">
        <div className="status-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 9v4"></path>
            <path d="M12 17h.01"></path>
            <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"></path>
          </svg>
        </div>
        <h2>Something went wrong</h2>
        <p>
          We hit an unexpected error. Your progress is safe — please try again, and if the problem
          continues, restart the app.
        </p>
        <Button className="retry-btn" onClick={handleRetry}>
          Try Again
        </Button>
      </div>
    </div>
  );
}
